export default __webpack_public_path__ + "static/media/DownloadConfigFileforUpload-MySQL.28827398.png";